import React, { useEffect } from 'react';
import useMediaQuery from '../../../hooks/useMediaQuery.js';
import MensajeCargando from '../../UI/MensajeCargando.js';
import MensajeError from '../../UI/MensajeError.js';
import SelectEtapaTorneo from '../../selectores/SelectEtapaTorneo.js';
import styles from './EtapasTorneo.module.css';

const EtapasTorneo = (props) => {
  const {
    etapas = [],
    etapaSeleccionada,
    isCargando = false,
    errores = null,
    onEtapaSeleccionada,
  } = props;

  const esMobile = useMediaQuery('(max-width: 600px)');

  // Seleccionar la primera etapa automáticamente
  useEffect(() => {
    if (etapas.length > 0 && !etapaSeleccionada) {
      onEtapaSeleccionada(etapas[0]);
    }
  }, [etapas, etapaSeleccionada, onEtapaSeleccionada]);

  const etapaElegidaHandler = (index) => {
    onEtapaSeleccionada(etapas[index]);
  };

  return (
    <React.Fragment>
      {!isCargando && etapas.length === 0 && (
        <div className={`${styles.sinEtapas}`}>No hay etapas definidas para el torneo</div>
      )}
      {!isCargando && etapas.length > 0 && (
        <React.Fragment>
          <div className={`${styles.titulo}`}>Etapa</div>
          {esMobile && (
            <div className={`${styles.comboEtapas}`}>
              <SelectEtapaTorneo
                etapas={etapas}
                etapaSeleccionada={etapaSeleccionada}
                onEtapaSeleccionada={onEtapaSeleccionada}
              />
            </div>
          )}
          {!esMobile && (
            <div className={`${styles.listado}`}>
              {!isCargando &&
                etapas.map((etapaTorneo, index) => (
                  <button
                    className={`${styles.etapa} ${
                      etapaSeleccionada && etapaSeleccionada.id === etapaTorneo.id
                        ? styles.elegido
                        : ''
                    }`}
                    key={etapaTorneo.id}
                    onClick={() => etapaElegidaHandler(index)}
                  >
                    {etapaTorneo.etapa?.descripcion}
                  </button>
                ))}
            </div>
          )}
        </React.Fragment>
      )}
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={errores} />
    </React.Fragment>
  );
};

export default EtapasTorneo;
